import React, { useState, useEffect, createRef, useRef } from 'react';
import CardContainer from '../../../components/card/card-container.jsx';
import Api from '../../../api/global.service';
import { subscribe, unsubscribe } from '../../../components/events';
import './entregas-x-productor.css';
import Swal from 'sweetalert2';
import Moment from 'moment';
import { useCoopConfig } from '../../../components/content/coop-config.jsx';
import ModalFirma from './modal-firma.jsx';
import { publish } from '../../../components/events.js';
import formatNumber from '../../../utils/formatNumber.js';
import SignatureAccount from '../../../components/forms/signature-account.jsx';
import transformWord from '../../../utils/transformWord.js';

const EntregasXProductorFirma = ({ pagos, data, cuenta, etiquetaAnticipos, metodosPago, pendientePago }) => {
  const [blocking, setBlocking] = useState(true);
  const dialog = createRef();
  const [imageURL, setImageURL] = useState(null);
  const coopConfig = useCoopConfig();

  const handleFirma = event => {
    setImageURL(event.detail);
  };

  useEffect(() => {
    subscribe('Firma::onSave', e => handleFirma(e));
    return () => {
      unsubscribe('Firma::onSave');
    };
  }, []);

  const enviarDatos = () => {
    const formData = new FormData();
    formData.append('firma_image', imageURL);
    for (var key in data) {
      let v = data[key];
      if (v instanceof Date) {
        v = Moment(v).format('yyyy-MM-DD');
      } else if (v instanceof Array) {
        v = JSON.stringify(v);
      }
      formData.append(key, v);
    }

    Api.createMultiPart('admin/acopios/entregas/pago_pendiente', formData)
      .then(response => {
        let dataResponse = response.data[0];
        setBlocking(false);
        Swal.fire({
          icon: 'success',
          title: '',
          text: `Se registró con éxito el pago`,
          allowOutsideClick: false,
        }).then(() => {
          setBlocking(false);
          window.location.href = `/admin/acopio/entregas_por_productor/list`;
        });
      })
      .catch(e => {
        console.log(e);
        setBlocking(false);
        Swal.fire({
          icon: 'error',
          title: '',
          text: e.response.data.message,
        });
      });
  };

  const showForm = () => {
    publish('Entrega::onReturn');
  };

  return (
    <div>
      <CardContainer height={'100%'}>
        <ModalFirma ref={dialog} title="Generar firma" productor_nombre={cuenta?.productor_nombre} />
        {/* header */}
        <div className="row">
          <div className="col-xl-8 col-lg-12 d-flex align-items-center">
            <span className="resumen-entrega-titulo">{'Resumen de pago pendiente'}</span>
          </div>
          <div className="col-xl-4 col-lg-6 resumen-entrega-valor">
            <button
              className="text-green"
              onClick={() => showForm()}
              type="button"
              style={{
                border: 0,
                background: 'white',
                paddingLeft: 0,
                marginTop: 4,
                fontSize: '16px !important',
              }}>
              <i className="fa fa-arrow-left"></i> Volver a editar
            </button>
          </div>
        </div>
        {/* pago */}
        <div className="pt-3">
          <div className="row">
            <div className="col-xl-12 resumen-entrega-subtitulo">Pago</div>
          </div>

          <div className="row">
            <div className="col-xl-8 col-lg-6 resumen-entrega-elemento">Saldo anterior</div>
            <div className="col-xl-4 col-lg-6 resumen-entrega-valor">
              {coopConfig.currency()?.symbol + ' ' + formatNumber(Number(pagos?.pagos_total) - Number(pagos?.pagos_pagado_total))}
            </div>
          </div>

          <div className="row">
            <div className="col-xl-8 col-lg-6 resumen-entrega-elemento">Monto pagado</div>
            <div className="col-xl-4 col-lg-6 resumen-entrega-valor">
              {coopConfig.currency()?.symbol + ' ' + formatNumber(data.monto_pagado)}
            </div>
          </div>

          {data.recuperacion_credito && Number(data.recuperacion_credito) > 0 && (
            <div className="row">
              <div className="col-xl-8 col-lg-6 resumen-entrega-elemento">
                Recuperación de {transformWord(etiquetaAnticipos, ['plural'])}
              </div>
              <div className="col-xl-4 col-lg-6 resumen-entrega-valor">
                {coopConfig.currency()?.symbol + ' ' + formatNumber(data.recuperacion_credito)}
              </div>
            </div>
          )}
          {metodosPago && metodosPago.length > 0 && !!data.id_metodo_pago && (
            <div className="row">
              <div className="col-xl-8 col-lg-6 resumen-entrega-elemento">{'Método de pago'}</div>
              <div className="col-xl-4 col-lg-6 resumen-entrega-valor">
                {metodosPago.find(metodo => metodo.value === data.id_metodo_pago)?.label || ''}
              </div>
            </div>
          )}
          {pendientePago && !isNaN(pendientePago) && (
            <div className="row">
              <div className="col-xl-8 col-lg-6 resumen-entrega-elemento">{'Pago pendiente'}</div>
              <div className="col-xl-4 col-lg-6 resumen-entrega-valor">
                {coopConfig.currency()?.symbol + ' ' + formatNumber(pendientePago)}
              </div>
            </div>
          )}
        </div>

        {/* firma */}
        <div className="pt-3">
          <SignatureAccount imageURL={imageURL} cuenta={cuenta} />
        </div>
        <button
          type="button"
          onClick={() => {
            dialog.current.show();
            setImageURL(null);
          }}
          style={{ marginTop: 0 }}
          className="btn btn-outline-secondary">
          Generar firma
        </button>

        <div className="row">
          <div className="col-xl-12 resumen-entrega-subtitulo pt-4">
            <button
              type="button"
              disabled={imageURL ? false : true}
              onClick={() => {
                enviarDatos();
              }}
              style={{ marginTop: 0 }}
              className="btn btn-sirio">
              Guardar
            </button>
          </div>
        </div>
      </CardContainer>
    </div>
  );
};

export default EntregasXProductorFirma;
